import { render, staticRenderFns } from "./Attract.vue?vue&type=template&id=bf828dbe&"
import script from "./Attract.vue?vue&type=script&lang=js&"
export * from "./Attract.vue?vue&type=script&lang=js&"
import style0 from "./Attract.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports